import api from '../api'

export function loadAdminOrganizations() {
  if (this.getState().loadingAdminOrganizations) return

  this.setState({
    loadingAdminOrganizations: true,
    errorLoadingAdminOrganizations: undefined,
  })

  return api.getOrganizationsWhereUserIsAdmin().then(
    ({ organizations }) => {
      this.setState({
        loadingAdminOrganizations: false,
        adminOrganizations: organizations,
      })
    },
    error => {
      this.setState({
        loadingAdminOrganizations: false,
        errorLoadingAdminOrganizations: error,
      })
    }
  )
}

export function loadOrganizationHierarchy(organizationApikey) {
  const stateKey = `organizationHierarchy:${organizationApikey}`
  const loadingKey = `${stateKey}:loading`
  const errorKey = `${stateKey}:error`

  if (this.getState()[loadingKey]) return

  this.setState({
    [loadingKey]: true,
    [errorKey]: undefined,
  })

  return api.getOrganizationHierarchy(organizationApikey).then(
    ({ hierarchy }) => {
      this.setState({
        [loadingKey]: false,
        [stateKey]: hierarchy,
      })
    },
    error => {
      this.setState({
        [loadingKey]: false,
        [errorKey]: error,
      })
    }
  )
}

export function convertNetworkType({
  organizationApikey,
  targetNetworkType,
  isMasterOrg,
  parentOrganizationApikey,
  onSuccess,
  onError
}) {
  const stateKey = `convertingNetworkType:${organizationApikey}`
  const errorKey = `${stateKey}:error`

  if (this.getState()[stateKey]) return

  this.setState({
    [stateKey]: true,
    [errorKey]: undefined,
  })

  return api.convertOrganizationNetworkType(
    organizationApikey,
    targetNetworkType,
    isMasterOrg,
    parentOrganizationApikey
  ).then(
    result => {
      this.setState({
        [stateKey]: false,
      })

      this.takeAction('organization.load', organizationApikey)

      if (onSuccess) onSuccess(result)

      this.takeAction('ui.showNotification', {
        type: 'success',
        message: `Successfully converted to ${targetNetworkType} network`,
      })
    },
    error => {
      this.setState({
        [stateKey]: false,
        [errorKey]: error,
      })

      if (onError) onError(error)

      this.takeAction('ui.showNotification', {
        type: 'error',
        message: error.message || 'Failed to convert network type',
      })
    }
  )
}

export function getOrganizationAdmins(organizationApikey) {
  const stateKey = `organizationAdmins:${organizationApikey}`
  const loadingKey = `${stateKey}:loading`
  const errorKey = `${stateKey}:error`

  if (this.getState()[loadingKey]) return

  this.setState({
    [loadingKey]: true,
    [errorKey]: undefined,
  })

  return api.getParentOrganizationAdmins(organizationApikey).then(
    ({ admins }) => {
      this.setState({
        [loadingKey]: false,
        [stateKey]: admins,
      })
      return admins
    },
    error => {
      this.setState({
        [loadingKey]: false,
        [errorKey]: error,
      })
      throw error
    }
  )
}
